import { render, staticRenderFns } from "./PlayerStarDied.vue?vue&type=template&id=292ee23c&scoped=true&"
import script from "./PlayerStarDied.vue?vue&type=script&lang=js&"
export * from "./PlayerStarDied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292ee23c",
  null
  
)

export default component.exports